import { Injectable } from "@angular/core";
import { ComponentStoreV2Factory } from "packages/client/src/app/modules/shared/store/common/component-store-v2.factory";

@Injectable()
export class WarehouseMaterialOperationTableStore extends ComponentStoreV2Factory {

}
